import React from 'react';
import { Icon } from 'semantic-ui-react';
import './InfoBanner.scss';

/**
 * InfoBanner - Reusable information banner component
 * Used for displaying informational messages with icon and optional description
 * 
 * @param {string} title - Main title/heading text
 * @param {string} description - Optional description text below title
 * @param {string} linkText - Optional link text (e.g., "Ver respaldo")
 * @param {string} linkUrl - Optional link URL
 * @param {string} icon - Icon name (default: "info circle")
 * @param {string} iconColor - Icon color (default: "blue")
 */
const InfoBanner = ({ 
  title, 
  description, 
  linkText,
  linkUrl,
  icon = "info circle", 
  iconColor = "blue" 
}) => {
  if (!title) return null;

  return (
    <div className="info-banner">
      <Icon name={icon} color={iconColor} />
      <div className="info-banner__content">
        <span className="info-banner__title">
          {title}
        </span>
        {description && (
          <p className="info-banner__description">
            {description}
          </p>
        )}
        {linkText && linkUrl && (
          <div className="info-banner__link">
            <a 
              href={linkUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="info-banner__link-text"
            >
              {linkText}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoBanner;
